import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface IndustryConversionSearchConditionState {
  conversionAfterIndustryCode: string;
  conversionAfterIndustryName: string;
  timestamp: number;
}

const initialState = {} as IndustryConversionSearchConditionState;

const industryConversionSearchConditionSlice = createSlice({
  name: "industryConversionSearchCondition",
  initialState,
  reducers: {
    createSearchCondition: (
      state,
      action: PayloadAction<IndustryConversionSearchConditionState>
    ) => {
      const {
        conversionAfterIndustryCode,
        conversionAfterIndustryName,
        timestamp,
      } = action.payload;

      state.conversionAfterIndustryCode = conversionAfterIndustryCode;
      state.conversionAfterIndustryName = conversionAfterIndustryName;
      state.timestamp = timestamp;
    },
  },
});

export const { createSearchCondition } =
  industryConversionSearchConditionSlice.actions;

export default industryConversionSearchConditionSlice.reducer;
